import React, {useContext} from "react";
import PropTypes from 'prop-types';
import moment from 'moment';
import {Icon} from 'semantic-ui-react'
import LanguageContext from '../../language';
import { ReservationStatusTypes } from '../../components/shared/statustypes';
import './styles.less'
import { dateFormatDotted } from "../../components/shared/constants";

const ApartmentOwnerReservationsList = ({reservations}) => {
    const language = useContext(LanguageContext)
    
    const text = key=>{
        return language?language.texts[key]:key
    }

    return (
        <div className={"reservations-list"}>
            <div className={"reservations-list-title"}>
                {text("UpcomingReservations")}
            </div>
           {
            reservations.map((reservation) => {
                const showAgentIcon = reservation.Agent && reservation.Agent.Icon;
                const showCompanyIcon = reservation.Company && reservation.Company.Icon;
                return(
                    <div className={"reservation-item-wrapper"} key={reservation.Id}>
                        <div className={"reservation-item-section"}>
                            <div className={"reservation-item-number"}>
                                #{reservation.Number}
                            </div>
                        </div>
                        
                        <div className={"reservation-item-section"}>
                            <div className={"reservation-item-check-in"}>
                                {moment(reservation.CheckInDate).format(dateFormatDotted)}
                            </div>
                            <Icon className={"reservation-item-icon"} name="arrow right" size="small"></Icon>
                            <div className={"reservation-item-check-out"}>
                                {moment(reservation.CheckOutDate).format(dateFormatDotted)}
                            </div>
                        </div>
                        <div className={"reservation-item-section"}>
                            <div className={"reservation-item-status"}>
                                {text(ReservationStatusTypes[reservation.StatusId])}
                            </div>
                            {   showAgentIcon &&
                                <div className={"reservation-item-agent"}>
                                    <img src={reservation.Agent.Icon} className="agent-icon"/>
                                </div>
                            }
                            {   !showAgentIcon && showCompanyIcon &&
                                <div className={"reservation-item-agent"}>
                                    <img src={reservation.Company.Icon} className="agent-icon"/>
                                </div>
                            }
                        </div>
                    </div>
                )
            })
           }
        </div>
    )
}

ApartmentOwnerReservationsList.propTypes = {
    reservations: PropTypes.array
}


export default ApartmentOwnerReservationsList;